import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../../utils";
import RoutesMap from "../../../../route_control/RouteControl"

export const slaAndPriorityDetailsTodo = createAsyncThunk('slaAndPriorityDetails', async ({ id, navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `sla_priority/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getSession("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const slaAndPriorityDetailsSlice = createSlice({
    name: 'slaAndPriorityDetails',
    initialState: {
        data: '',
    },
    extraReducers: (builder) => {
        builder.addCase(slaAndPriorityDetailsTodo.fulfilled, (state, action) => {
            if (action?.payload?.status == 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status == 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status == 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = ''
            }

        });
        builder.addCase(slaAndPriorityDetailsTodo.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default slaAndPriorityDetailsSlice.reducer; 